"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

var use_set_action_preview_hook_1 = __importDefault(require("../action-preview/use-set-action-preview.hook"));

var styled_components_1 = require("styled-components");

var editable_image_scenario_node_styles_1 = require("./editable-image-scenario-node.styles");

var editable_action_view_component_1 = __importDefault(require("../editable-action-view/editable-action-view.component"));

var editable_image_option_view_container_1 = __importDefault(require("../editable-image-option-view/editable-image-option-view.container"));

var add_image_option_button_container_1 = __importDefault(require("../add-image-option-button/add-image-option-button.container"));

var remove_option_button_container_1 = __importDefault(require("../remove-option-button/remove-option-button.container"));
/**
 * iamgeScenarioNode options 最大値
 */


exports.MAX_IMAGE_OPTIONS_LENGTH = 10;

var EditableImageOptionListItem = function EditableImageOptionListItem(_ref) {
  var nodeId = _ref.nodeId,
      option = _ref.option,
      optionIndex = _ref.optionIndex,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave;
  return react_1.default.createElement(editable_image_scenario_node_styles_1.StyledEditableOptionLi, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, react_1.default.createElement(editable_image_option_view_container_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex,
    option: option
  }), react_1.default.createElement(editable_image_scenario_node_styles_1.StyledRemoveOptionButtonWrapperDiv, null, react_1.default.createElement(remove_option_button_container_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex,
    size: "large"
  })), react_1.default.createElement(editable_image_scenario_node_styles_1.StyledActionViewWrapperDiv, null, react_1.default.createElement(editable_action_view_component_1.default, {
    nodeId: nodeId,
    option: option,
    optionIndex: optionIndex,
    direction: "column"
  })));
};

var EditableImageOptionListItemContainer = function EditableImageOptionListItemContainer(props) {
  var _use_set_action_previ = use_set_action_preview_hook_1.default(),
      setActionPreview = _use_set_action_previ.setActionPreview,
      resetActionPreview = _use_set_action_previ.resetActionPreview;

  return react_1.default.createElement(EditableImageOptionListItem, Object.assign({
    handleMouseEnter: function handleMouseEnter() {
      setActionPreview(props.option);
    },
    handleMouseLeave: function handleMouseLeave() {
      resetActionPreview();
    }
  }, props));
};

var EditableImageScenarioNode = function EditableImageScenarioNode(_ref2) {
  var nodeId = _ref2.nodeId,
      node = _ref2.node,
      _ref2$scale = _ref2.scale,
      scale = _ref2$scale === void 0 ? 1 : _ref2$scale;
  var options = node.options;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: scenario_node_view_styles_1.initNodeTheme(scale)
  }, react_1.default.createElement(editable_image_scenario_node_styles_1.StyledEditableImageNodeWrapperDiv, null, react_1.default.createElement(editable_image_scenario_node_styles_1.StyledEditableOptionsUl, null, options.map(function (option, i) {
    return react_1.default.createElement(EditableImageOptionListItemContainer, {
      key: i,
      nodeId: nodeId,
      option: option,
      optionIndex: i
    });
  }), options.length < exports.MAX_IMAGE_OPTIONS_LENGTH && react_1.default.createElement(editable_image_scenario_node_styles_1.StyledEditableOptionLi, null, react_1.default.createElement(add_image_option_button_container_1.default, {
    nodeId: nodeId
  })))));
};

exports.default = EditableImageScenarioNode;